module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma_excellence/root-en-5a13b098193fbc2067a610d494592ff8.svg";